import { render, staticRenderFns } from "./addRewardRainCampaign.vue?vue&type=template&id=5a4b4d8a&lang=pug"
import script from "./addRewardRainCampaign.vue?vue&type=script&lang=js"
export * from "./addRewardRainCampaign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports